import { render, staticRenderFns } from "./SalesManagmentMassiveEntry.vue?vue&type=template&id=95837490&scoped=true"
import script from "./SalesManagmentMassiveEntry.vue?vue&type=script&lang=js"
export * from "./SalesManagmentMassiveEntry.vue?vue&type=script&lang=js"
import style0 from "./SalesManagmentMassiveEntry.vue?vue&type=style&index=0&id=95837490&prod&scoped=true&lang=css"
import style1 from "./SalesManagmentMassiveEntry.vue?vue&type=style&index=1&id=95837490&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95837490",
  null
  
)

export default component.exports